
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M19.9999 15.31L22.5999 12.71C22.9899 12.32 22.9899 11.69 22.5999 11.3L19.9999 8.69V5C19.9999 4.45 19.5499 4 18.9999 4H15.3099L12.7099 1.4C12.3199 1.01 11.6899 1.01 11.2999 1.4L8.68992 4H4.99992C4.44992 4 3.99992 4.45 3.99992 5V8.69L1.39992 11.29C1.00992 11.68 1.00992 12.31 1.39992 12.7L3.99992 15.3V19C3.99992 19.55 4.44992 20 4.99992 20H8.68992L11.2899 22.6C11.6799 22.99 12.3099 22.99 12.6999 22.6L15.2999 20H18.9999C19.5499 20 19.9999 19.55 19.9999 19V15.31ZM11.9999 16.9V7.1C11.9999 6.49 12.5499 5.99 13.1499 6.11C15.9099 6.65 17.9999 9.08 17.9999 12C17.9999 14.92 15.9099 17.35 13.1499 17.89C12.5499 18.01 11.9999 17.51 11.9999 16.9Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-brightness-6`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconBrightness6

    ```js
    <b-new-b-icon-brightness-6 />
    ```
</docs>


